import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import { 
  range, 
  getMonthName, 
  getMonthNameFull, 
  getWeekDayName, 
  CREATE_BOOKING, 
  cutString2, 
  isoTimeTo24HourConverter,
  typeMonthSelector,
  BOOKING_STATUS,
  MODAL_CONFIRM,
  HOLIDAY_HEADER,
} from '../../helpers'

import Style from './style'
import { COLOR } from '../../themes'

const defaultList = []
class MonthPicker extends React.Component {
  constructor(props) {
    super(props)
    props = Object.assign({}, props)
    const allDayInWeek = range(4, 11, 1)
    this.dayInWeek = allDayInWeek.map((day) => {
      return getWeekDayName(new Date(1970, 0, day), props.language)
    })
    const allMonth = range(0, 12, 1)
    this.monthInYear = allMonth.map((month) => {
      return getMonthNameFull(new Date(1970, month, 1), props.language)
    })
    let selectedDate = new Date(props.year, props.month - 1, props.date, 0, -new Date().getTimezoneOffset())
    props.selectDate = props.selectDate != null ? props.selectDate : new Date()
    this.weekend = props.weekend ? props.weekend : defaultList
    const startOfMonth = new Date(props.selectDate.getFullYear(), props.selectDate.getMonth(), 1)
    if (props.startSelectable != null) {
      this.startSelectableYear = new Date(props.startSelectable.getFullYear(), 0, 1)
      this.startSelectableMonth = new Date(props.startSelectable.getFullYear(), props.startSelectable.getMonth(), 1)
      this.startSelectableDate = new Date(props.startSelectable.getFullYear(), props.startSelectable.getMonth(), props.startSelectable.getDate())
    }

    if (props.endSelectable != null) {
      this.endSelectableYear = new Date(props.endSelectable.getFullYear(), 0, 1)
      this.endSelectableMonth = new Date(props.endSelectable.getFullYear(), props.endSelectable.getMonth(), 1)
      this.endSelectableDate = new Date(props.endSelectable.getFullYear(), props.endSelectable.getMonth(), props.endSelectable.getDate())
    }

    this.oneDay = 24 * 60 * 60 * 1000
    this.oneMonth = 30 * this.oneDay
    this.oneYear = 12 * this.oneMonth
    this.state = {
      selectedDate: selectedDate,
      width: window.innerWidth,
      isShowingDate: true,
      isShowingMonth: false,
      isShowingYear: false,
      doReRender: false,
      selectDate: props.selectDate ? props.selectDate.getDate() : null,
      startDay: props.selectDate ? startOfMonth.getDay() : null,
      selectMonth: props.selectDate ? props.selectDate.getMonth() : null,
      selectYear: props.selectDate ? props.selectDate.getFullYear() : null,
      tempMonth: props.tempDate ? props.tempDate.getMonth() : null,
      tempYear: props.tempDate ? props.tempDate.getFullYear() : null,
      view: props.view.toLowerCase(),
    }
  }

  componentDidMount () {
    this.resize = this.handleresize.bind(this)
    window.addEventListener('resize', this.resize, false)
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.resize, false)
  }
  handleresize () {
    this.setState({
      width: window.innerWidth
    })
  }

  detectOnchangeDate () {
    const { pathChange } = this.props
    const { selectDate, selectMonth, selectYear } = this.state
    let object = { selectDate, selectMonth, selectYear }
    pathChange(object)
  }

  getTotalDayInMonth (month = (new Date()).getMonth(), year = (new Date()).getFullYear()) {
    return 32 - (new Date(year, month, 32)).getDate()
  }

  increaseMonth = () => {
    let newDate = new Date(this.state.selectYear, this.state.selectMonth + 1, 1)
    this.setState({
      isShowingMonth: false,
      isShowingYear: false,
      selectMonth: newDate.getMonth(),
      selectYear: newDate.getFullYear(),
      startDay: newDate.getDay(),
      doReRender: !this.state.doReRender
    })
  }

  decreaseMonth = () => {
    let newDate = new Date(this.state.selectYear, this.state.selectMonth - 1, 1)
    this.setState({
      isShowingMonth: false,
      isShowingYear: false,
      selectMonth: newDate.getMonth(),
      selectYear: newDate.getFullYear(),
      startDay: newDate.getDay(),
      doReRender: !this.state.doReRender
    })
  }

  getMonth (disabledList = defaultList, today = new Date()) {
    const selectYear = this.state.selectYear
    const selectMonth = this.state.selectMonth
    const todayMonth = today.getMonth()
    return this.monthInYear.map((month, index) => {
      let className = 'currentCar'
      let disabled = null
      const monthObject = new Date(selectYear, index, 1)
      if (this.startSelectableMonth != null && monthObject < this.startSelectableMonth) {
        disabled = true
      } else if (this.endSelectableMonth != null && monthObject > this.endSelectableMonth) {
        disabled = true
      } else if (disabledList.includes(month)) disabled = true
      if (index === todayMonth) className = className.concat(' today')
      if (index === selectMonth) className = className.concat(' selectDate')
      return (
        <button
          key={month}
          className={className}
          disabled={disabled}
          onClick={(event) => { this.handleMonthSelect(event, index) }}
        >
          <h3>{month}</h3>
        </button>
      )
    })
  }

  getYear (disabledList = defaultList, startYear = null, endYear = null, today = new Date()) {
    const result = []
    const selectYear = this.state.selectYear
    const todayYear = today.getFullYear()
    if (startYear == null) startYear = (selectYear != null ? selectYear : todayYear) - 10
    if (endYear == null) endYear = (selectYear != null ? selectYear : todayYear) + 10

    for (let year = startYear; year <= endYear; year++) {
      let disabled = null
      let className = 'currentCar'
      const yearObject = new Date(year, 0, 1)
      if (this.startSelectableYear != null && yearObject < this.startSelectableYear) {
        disabled = true
      } else if (this.endSelectableYear != null && yearObject > this.endSelectableYear) {
        disabled = true
      } else if (disabledList.includes(year)) disabled = true
      if (year === todayYear) className = className.concat(' today')
      if (year === selectYear) className = className.concat(' selectDate')
      result.push(
        <button
          key={year}
          className={className}
          disabled={disabled}
          onClick={(event) => { this.handleYearSelect(event, year) }}
        >
          <h3>{year}</h3>
        </button>
      )
    }
    return result
  }

  renderList = (data) => {
    return (
      <div className='table-booking'> {this.renderitem(data)}</div>
    )
  }

  renderitem (data) {
    let dateobj = []
    const meetList = window.screen.height <= 800 ? 2 : 3

    return data.map((res, index) => {
      dateobj = [...dateobj, res]

      return (
        index < meetList ?
          <div id={`meeting-${res.id}`} className={`pointer ${res.status === BOOKING_STATUS.IN_USE ? 'alive' : 'list-booking'}`} key={index} onClick={(e) => { this.props.onClickDetail(e, res) }}>
            <div className='title'>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 16 16"><circle className="a" cx="8" cy="8" r="8" /></svg>
              <span className='sub_title'>{res.time} {cutString2(res.projectName, ((this.state.width / 100) - 5.5))}</span>
            </div>
          </div> : data.length - index === data.length - meetList ?
            <div className='list-booking pointer' key={index} onClick={(e) => { this.props.onClickMore(e, dateobj) }}>
              <div className='title more'> <span>{data.length - index} {CREATE_BOOKING.MORE[this.props.language]}</span> </div></div>
            : null)
    })
  }

  getCalendar (startDayInWeek = 0, disabledList = defaultList, today = new Date()) {
    const selectDate = this.state.selectDate ? this.state.selectDate : today.getDate()
    const selectMonth = this.state.selectMonth
    const selectYear = this.state.selectYear
    const tempMonth = this.state.tempMonth
    const tempYear = this.state.tempYear
    const weekend = this.weekend
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate())
    const todayMonth = new Date(today.getFullYear(), today.getMonth(), 1)
    const lastDayOfThisMonth = this.getTotalDayInMonth(selectMonth != null ? selectMonth : todayMonth.getMonth(), selectYear != null ? selectYear : todayMonth.getFullYear())
    const lastMonth = new Date(selectYear != null ? selectYear : todayMonth.getFullYear(), selectMonth != null ? selectMonth - 1 : todayMonth.getMonth() - 1, 1)
    const lastDayOfPreMonth = this.getTotalDayInMonth(lastMonth.getMonth(), lastMonth.getFullYear())
    let startDay = this.state.startDay != null ? this.state.startDay : todayMonth.getDay()

    const getDayStyle = (isHoliday, day) => {
      const color = isHoliday || day === 'Sun' || day === 'Sat'
        ? COLOR.GRAY_20
        : COLOR.BLACK_1
      return { color }
    }
    
    const groupBooking = {}
    for (const bookingItem of this.props.bookingcalendarReducer.list) {
      const [isoDateTime, isoTime] = bookingItem.startDatetime.split('T')
      const isoDate = new Date(isoDateTime).getDate()
      const isoMonth = new Date(isoDateTime).getMonth()
      const isoYear = new Date(isoDateTime).getFullYear()

      const month = new Date(selectYear, selectMonth, 1)
      const time24HourFormat = isoTimeTo24HourConverter(isoTime)
      const typemonth = typeMonthSelector(isoMonth, isoYear, selectYear, month)

      const isRepeat = Boolean(bookingItem.recurrence)

      const recurrence = isRepeat ? bookingItem.recurrence : null

      const bookingProperties = {
        id: bookingItem.id,
        time: time24HourFormat,
        date: isoDate,
        typemonth: typemonth,
        projectName: bookingItem.projectName,
        owner: bookingItem.owner,
        roomId: bookingItem.roomId,
        roomName: bookingItem.roomName,
        startDatetime: bookingItem.startDatetime,
        endDatetime: bookingItem.endDatetime,
        status: bookingItem.status,
        description: bookingItem.description,
        recurrence,
        meetingLink: bookingItem.meetingLink,
        meetingLinkType: bookingItem.meetingLinkType,
        isEditable: bookingItem.isEditable
      }

      if (groupBooking[isoDate]) {
        groupBooking[isoDate] = [...groupBooking[isoDate], bookingProperties]
      } else {
        groupBooking[isoDate] = [bookingProperties]
      }
    }

    if (startDay > startDayInWeek) {
      startDay = startDay - startDayInWeek
    } else if (startDay < startDayInWeek) {
      startDay = startDay + 7 - startDayInWeek
    }

    const result = []

    for (let i = lastDayOfPreMonth - (startDay - 1); i <= lastDayOfPreMonth; i++) {
      let month = new Date(selectYear, selectMonth, 1).getMonth()

      if (month === 11) {
        month = 10
      } else if (month === 0) {
        month = 11
      } else {
        month = month - 1
      }
      let datalist = []
      if (groupBooking[i]) {
        groupBooking[i].map((res) => {
          if (res.typemonth === 0 || res.typemonth === 3) {
            datalist.push(res)
          }
          return true
        })
      }
      let past = getMonthName(new Date(1970, month, 1), this.props.language)
      // Previous month
      result.push(
        <button
          key={'prev car' + i}
          className='prevCar pointer'
          onClick={() => this.props.goToCreateBookingDate(this.props, i, 0)}
        >
          <p>{i === lastDayOfPreMonth ? past : null} {i}</p>
          {datalist.length !== 0 ? this.renderList(datalist) : null}
        </button>
      )
    }

    for (let i = 1; i < selectDate; i++) {
      const thisToday = moment(new Date(selectYear, selectMonth, i)).format('YYYY-MM-DD')
      const newHoliday = this.props.holidayReducer.listHoliday.filter(res => res.date === thisToday && res.date)
      const isHoliday = this.props.holidayReducer.listHoliday.some(item => item.date === thisToday)
      const findIndexHoliday = newHoliday.map(e => new Date(e.date).getDate()).indexOf(i)
      const findEleHoliday = newHoliday.find((res, index) => index === findIndexHoliday && res.holidayName)
      let disabled = null
      let className = 'currentCar pointer'
      if (weekend.includes((startDay + i - 1 + startDayInWeek) % 7)) {
        disabled = true
      }
      if (today.valueOf() === new Date(selectYear, selectMonth, i).valueOf()) {
        className = className.concat(' today pointer')
      }
      let datalist = []
      if (groupBooking[i]) {
        groupBooking[i].map((res) => {
          if (res.typemonth === 1) {
            datalist.push(res)
          }
          return true
        })
      }

      const dayInWeek = this.dayInWeek[(i + startDay - 1 + startDayInWeek) % 7]
      className = className.concat(' ' + dayInWeek)
      // 1st, 2nd, 3rd in current month
      result.push(
        <button
          key={'cur holiday' + i}
          disabled={disabled}
          className={className + `${findIndexHoliday > -1 ? ' month-view-holiday' : ''}`}
          onClick={() => this.props.goToCreateBookingDate(this.props, i, 1)}
        >
          <p style={getDayStyle(isHoliday, dayInWeek)}>{i}</p>
          {datalist.length !== 0 ? (
            <div>
              {findIndexHoliday > -1 && (
                <div className='table-booking'>
                  <div className='title-holiday' onClick={(event) => { this.props.onClickInformation(event, {headerName: HOLIDAY_HEADER[this.props.language], descriptionName: findEleHoliday.holidayName, buttonName: MODAL_CONFIRM.OK[this.props.language]})}}>{findEleHoliday.holidayName}</div>
                </div>
              )}
              {this.renderList(datalist)}
            </div>
          ) : (
            findIndexHoliday > -1 && (
              <div className='table-booking'>
                <div className='title-holiday' onClick={(event) => { this.props.onClickInformation(event, {headerName: HOLIDAY_HEADER[this.props.language], descriptionName: findEleHoliday.holidayName, buttonName: MODAL_CONFIRM.OK[this.props.language]})}}>{findEleHoliday.holidayName}</div>
              </div>
            )
          )}
        </button>
      )
    }

    let disabled = null
    let className = 'currentCar'
    if (weekend.includes((startDay + selectDate - 1 + startDayInWeek) % 7)) {
      disabled = true
    }

    if (today.valueOf() === new Date(selectYear, selectMonth, selectDate).valueOf()) {
      className = className.concat(' today pointer')
    }
    if (tempMonth === selectMonth && tempYear === selectYear) {
      className = className.concat(' selectDate pointer')
    }
    const dayInWeek = this.dayInWeek[(selectDate + startDay - 1 + startDayInWeek) % 7]
    className = className.concat(' ' + dayInWeek)
    let datalist = []
    if (groupBooking[selectDate]) {
      groupBooking[selectDate].map((res) => {
        if (res.typemonth === 1) {
          datalist.push(res)
        }
        return true
      })
    }
    const thisToday = moment(new Date(selectYear, selectMonth, selectDate)).format('YYYY-MM-DD')
    const isHoliday = this.props.holidayReducer.listHoliday.some(item => item.date === thisToday)
    const newHoliday = this.props.holidayReducer.listHoliday.filter(res => res.date === thisToday && res.date)
    // 4th in current month
    result.push(
      <button
        key={'cur holiday select' + selectDate}
        disabled={disabled}
        className={className + `${isHoliday ? ' month-view-holiday' : ''}`}
        onClick={() => this.props.goToCreateBookingDate(this.props, selectDate, 1)}
      >
        <p style={getDayStyle(isHoliday, dayInWeek)}>{selectDate}</p>
        {datalist.length !== 0 ? (
          <div>
            {newHoliday.length > 0 && (
              <div className='table-booking'>
                <div className='title-holiday' onClick={(event) => {this.props.onClickInformation(event, {headerName: HOLIDAY_HEADER[this.props.language], descriptionName: newHoliday[0]?.holidayName, buttonName: MODAL_CONFIRM.OK[this.props.language]})}}>{newHoliday[0]?.holidayName}</div>
              </div>
            )}
            {this.renderList(datalist)}
          </div>
        ) : (
          newHoliday.length > 0 && (
            <div className='table-booking'>
              <div className='title-holiday' onClick={(event) => {this.props.onClickInformation(event, {headerName: HOLIDAY_HEADER[this.props.language], descriptionName: newHoliday[0]?.holidayName, buttonName: MODAL_CONFIRM.OK[this.props.language]})}}>{newHoliday[0]?.holidayName}</div>
            </div>
          )
        )}
      </button>
    )

    for (let i = selectDate + 1; i <= lastDayOfThisMonth; i++) {
      const thisToday = moment(new Date(selectYear, selectMonth, i)).format('YYYY-MM-DD')
      const newHoliday = this.props.holidayReducer.listHoliday.filter(res => res.date === thisToday && res.date)
      const findIndexHoliday = newHoliday.map(e => new Date(e.date).getDate()).indexOf(i)
      const findEleHoliday = newHoliday.find((res, index) => index === findIndexHoliday && res.holidayName)
      const isHoliday = this.props.holidayReducer.listHoliday.some(item => item.date === thisToday)
      let disabled = null
      let className = 'currentCar pointer'

      if (weekend.includes((startDay + i - 1 + startDayInWeek) % 7)) {
        disabled = true
      }

      if (today.valueOf() === new Date(selectYear, selectMonth, i).valueOf()) {
        className = className.concat(' today')
      }
      let datalist = []
      if (groupBooking[i]) {
        groupBooking[i].map((res) => {
          if (res.typemonth === 1) {
            datalist.push(res)
          }
          return true
        })
      }
      const dayInWeek = this.dayInWeek[(i + startDay - 1 + startDayInWeek) % 7]
      className = className.concat(' ' + dayInWeek)
      // current month
      result.push(
        <button
          key={'cur pointer' + i}
          disabled={disabled}
          className={className + `${findIndexHoliday > -1 ? ' month-view-holiday' : ''}`}
          onClick={() => this.props.goToCreateBookingDate(this.props, i, 1)}
        >
          <p style={getDayStyle(isHoliday, dayInWeek)}>{i}</p>
          {datalist.length !== 0 ? (
            <div>
              {findIndexHoliday > -1 && (
                <div className='table-booking'>
                  <div className='title-holiday' onClick={(event) => {this.props.onClickInformation(event, {headerName: HOLIDAY_HEADER[this.props.language], descriptionName: findEleHoliday.holidayName, buttonName: MODAL_CONFIRM.OK[this.props.language]})}}>{findEleHoliday.holidayName}</div>
                </div>
              )}
              {this.renderList(datalist)}
            </div>
          ) : (
            findIndexHoliday > -1 && (
              <div className='table-booking'>
                <div className='title-holiday' onClick={(event) => {this.props.onClickInformation(event, {headerName: HOLIDAY_HEADER[this.props.language], descriptionName: findEleHoliday.holidayName, buttonName: MODAL_CONFIRM.OK[this.props.language]})}}>{findEleHoliday.holidayName}</div>
              </div>
            )
          )}
        </button>
      )
    }
    const totalDay = Math.ceil((startDay + lastDayOfThisMonth) / 7) * 7
    for (let i = 1; i <= totalDay - (lastDayOfThisMonth + startDay); i++) {
      let month = new Date(selectYear, selectMonth, 1).getMonth()
      if (month === 11) month = 0
      else month = month + 1
      let datalist = []
      if (groupBooking[i]) {
        datalist = [...groupBooking[i].filter(f => f.typemonth === 2 || f.typemonth === 3)]
      }
      let next = getMonthName(new Date(1970, month, 1), this.props.language)
      const today = moment(new Date(selectYear, selectMonth + 1, i)).format('YYYY-MM-DD')
      const newHolidayFirstDate = this.props.holidayReducer.listHoliday.find(res => res.date === today && res)
      const renderNextMonth = () => i === 1 ? next : null
      const renderHolidayOrBookingList = () => {
        let dateForRender
        if (datalist.length !== 0) dateForRender = this.renderList(datalist)
        if (newHolidayFirstDate) dateForRender = (
          <div className='table-booking'>
            <div className='title-holiday'>{newHolidayFirstDate.holidayName}</div>
          </div>
        )
        return dateForRender
      }
      result.push(
        <button
          key={'nextCar pointer' + i}
          className='nextCar pointer'
          onClick={() => this.props.goToCreateBookingDate(this.props, i, 2)}
        >
          <p> {renderNextMonth()} {i}</p>
          {renderHolidayOrBookingList()}
        </button>
      )
    }

    return result
  }

  toggleMonthView () {
    this.setState({
      isShowingMonth: !this.state.isShowingMonth,
      isShowingYear: false
    })
  }

  toggleYearView () {
    this.setState({
      isShowingYear: !this.state.isShowingYear,
      isShowingMonth: false
    })
  }

  render () {
    const props = Object.assign({}, this.props)
    const month = this.state.selectMonth != null ? this.state.selectMonth : new Date().getMonth()
    const year = this.state.selectYear != null ? this.state.selectYear : new Date().getFullYear()

    return (
      <Style
        colorTheme={props.colorTheme}
        dayInWeek={this.dayInWeek}
      >
        <section className='DatePicker jump-in'>
          <section className='calendarField'>

            <section className={
              'calendarDay ' + ((this.state.isShowingMonth || this.state.isShowingYear) ? 'fade-out' : 'fade-in')
            }
            >
              {this.props.bookingcalendarReducer.list ? this.getCalendar(
                props.startDay ? props.startDay : 0,
                (props.disabledDate &&
                  props.disabledDate[year] &&
                  props.disabledDate[year][month]) ? props.disabledDate[year][month] : defaultList) : null}
            </section>
            {this.state.isShowingMonth
              ? <section className='calendarMonth slide-in' isshowing={Boolean(this.state.isShowingMonth).toString()}>
                {this.getMonth((props.disabledMonth && props.disabledMonth[year]) ? props.disabledMonth[year] : defaultList)}
              </section>
              : null}
            {this.state.isShowingYear
              ? <section className='calendarYear slide-in' isshowing={Boolean(this.state.isShowingYear).toString()}>
                {this.getYear(props.disabledYear ? props.disabledYear : defaultList, props.startYear, props.endYear)}
              </section>
              : null}
          </section>
        </section>
      </Style>
    )
  }
}

MonthPicker.propTypes = {
  selectDate: PropTypes.instanceOf(Date),
  startSelectable: PropTypes.instanceOf(Date),
  endSelectable: PropTypes.instanceOf(Date),
  startDay: PropTypes.number,
  startYear: PropTypes.number,
  endYear: PropTypes.number,
  isShowing: PropTypes.bool
}

export default MonthPicker
